/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
import Article from './Article';

export default class LiteraryWork extends Model {
	rating() {
		return Model.attribute<number>('rating').call(this);
	}

	articles() {
		return Model.hasMany<Article>('articles').call(this);
	}

	mainArticle() {
		return Model.hasOne<Article>('mainArticle').call(this);
	}
}
